import * as priceHelpers from "../common/helpers/priceOffer";
import { summaryResourceKeys as resourceKeys } from "../summary/common/resources";
import * as uiHelpers from "../common/helpers/ui";

export class Discount {
	constructor({ priceOffer, resources }) {
		if (priceOffer) {
			this.isDefaultDiscount = priceOffer.isPromotionalDefault;
			if (resources) {
				this.prefix = resources[resourceKeys.DISCOUNT_PREFIX];
			}
			this.text = priceHelpers.getDiscount(priceOffer, this.prefix);
			this.value = priceHelpers.getDiscountValue(priceOffer);
			this.cssClass = uiHelpers.getDiscountCssClass(this.isDefaultDiscount);
		}
	}

	isValid() {
		return !!this.text;
	}
}

export class InstallmentsDiscount extends Discount {
	constructor({ priceOffer, resources }) {
		super({ priceOffer, resources });
		let defaultSuffixResource = null;
		if (resources) {
			defaultSuffixResource = resources[resourceKeys.DISCOUNT_DESCRIPTION_TEXT];
		}
		this.text = priceHelpers.getInstallmentsDiscount(priceOffer, {
			resource: defaultSuffixResource,
			prefix: this.prefix
		});
		this.value = priceHelpers.getTotalDiscountValue(priceOffer);
	}
}
